export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const directions = [
    'Обратная связь', 'Сложные разговоры', 'Критика',
    'Конфликты', 'Ошибки', 'Развитие сотрудников',
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20calm%20professional%20one%20on%20one%20conversation%20between%20a%20manager%20and%20an%20employee%20in%20a%20bright%20modern%20minimalist%20office%20interior%20with%20floor%20to%20ceiling%20windows%20and%20soft%20natural%20daylight%20streaming%20in%2C%20two%20people%20sitting%20across%20from%20each%20other%20at%20a%20clean%20desk%2C%20relaxed%20but%20focused%20body%20language%2C%20constructive%20and%20respectful%20dialogue%20atmosphere%20not%20conflict%20not%20aggression%2C%20neutral%20warm%20beige%20and%20ivory%20tones%20with%20subtle%20sage%20green%20accents%20in%20the%20decor%2C%20warm%20wood%20table%20texture%2C%20blurred%20green%20plants%20in%20background%2C%20architectural%20photography%20with%20shallow%20depth%20of%20field%2C%20editorial%20corporate%20style%2C%20serene%20and%20trustworthy%20mood%2C%20no%20text%20no%20logos%20no%20branding&width=1920&height=1080&seq=feedback-hero-2026&orientation=landscape"
          alt="Обучение обратной связи и сложным разговорам для руководителей"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/65 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-32 md:pt-24 pb-12 md:pb-16">
        <div className="max-w-3xl">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white mb-5 leading-tight">
            Обратная связь и сложные разговоры: учим руководителей говорить о сложном и менять поведение сотрудников
          </h1>
          <p className="text-sm md:text-lg text-white/85 mb-4 leading-relaxed max-w-xl">
            Как обсуждать ошибки, невыполнение задач, конфликты, результаты и ожидания так, чтобы разговор приводил к изменениям, а не к обиде, сопротивлению или формальному согласию.
          </p>
          <p className="text-sm text-white/60 mb-6">
            Практическая корпоративная программа для руководителей и управленческих команд в Минске, Беларуси и онлайн.
          </p>

          <div className="flex flex-wrap gap-2 mb-8">
            {directions.map((dir) => (
              <span key={dir} className="bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 px-3 py-1.5 rounded-full text-xs font-medium">
                {dir}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => scrollTo('contact')}
              className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Получить программу
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollTo('contact')}
              className="border border-white/30 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-white/10 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Обсудить задачу
              <i className="ri-chat-3-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}